import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Paper, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { GetProductsQuery } from "../../../__generated__/graphql";
import { getCloudinaryUrl } from "../../../helpers/cloudinary";
import { colors } from "../../../helpers/colors";

type Product = NonNullable<GetProductsQuery["products"]["records"]>[number];
type TourCardProps = {
  product: Product;
  bla?: boolean;
};

export default function TourCard(props: TourCardProps) {
  const product = props.product;

  return (
    <Box>
      <Link to={`/tours/${product.id}`}>
        {product.mainImage && (
          <Paper
            elevation={5}
            sx={{
              height: 200,
              backgroundImage: `url(${getCloudinaryUrl(
                "image",
                product.mainImage,
                { height: 400 }
              )})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />
        )}
      </Link>

      <Stack sx={{ marginTop: "10px" }} spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <div
            style={{
              color: colors.coralRed,
              fontSize: "14px",
            }}
          >
            {product.location.translation?.name}
          </div>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <AccessTimeIcon sx={{ fontSize: "16px" }} />
            <span
              style={{
                fontSize: "14px",
              }}
            >
              {product.duration / 60} hours
            </span>
          </Stack>
        </Stack>
        <Link
          to={`/tours/${product.id}`}
          style={{ textDecoration: "none", color: "black" }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            {product.translation?.name}
          </div>
        </Link>

        {!props.bla && (
          <>
            <div style={{ fontSize: "14px" }}>
              {product.translation?.metaDescription}
            </div>
            <div style={{ fontSize: "16px" }}>
              From{" "}
              <b>
                {Intl.NumberFormat("ja-JP", {
                  style: "currency",
                  currency: product.mainPrice.currency,
                }).format(product.mainPrice.amount)}
              </b>{" "}
              / {product.mainPrice.isGroup ? "group" : "person"}
            </div>
          </>
        )}
      </Stack>
    </Box>
  );
}
